import React, {useState, useEffect, useRef, useMemo} from "../../../__snowpack__/pkg/react.js";
import {Modal, Button, Row, Col, Checkbox, Spin} from "../../../__snowpack__/pkg/antd.js";
import {isEmpty} from "../../../__snowpack__/pkg/lodash.js";
import {axios} from "../../lib/axios.js";
import {useUpdateRoute} from "../../lib/useIframe.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import checkImage from "./clone-store/check.png";
import cloneImage from "./clone-store/clone.png";
import storeImage from "./clone-store/store.png";
import {localeMessage} from "./i18n.js";
import {useIntlTyped} from "../../lib/useIntlTyped.js";
import {handleError} from "../../lib/errorHandler.js";
import {CLONE_PATH_ENUM, CHANNEL_TYPE_ENUM} from "./constant.js";
import qs from "../../../__snowpack__/pkg/query-string.js";
import {useShopsModel} from "../../entities/useShops.js";
import {getSortChannelList} from "../../lib/util.js";
import ChannelIcon from "../ChannelIcon.js";
import request from "../../utils/request/index.js";
const CheckboxGroup = Checkbox.Group;
const ProductCopyModalStyled = styled.div`
  .default-tip {
    background: rgba(96, 32, 255, 0.12);
    border-radius: 4px;
    border: 1px solid rgba(96, 32, 255, 0.3);
    padding: 10px 16px;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .info-circle {
      color: #6020ff !important;
    }
    span {
      flex: 1;
      padding-left: 8px;
    }
  }

  .store-default-checked {
    .checked-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 17px;
      span {
        font-size: 16px;
        color: #000000;
        font-family: ArialMT !important;
      }
      b {
        font-size: 16px;
        color: #52c41a;
        padding-left: 8px;
        padding-right: 6px;
      }
    }
    .checked-btn {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .ant-btn-lg {
        margin-bottom: 18px;
        width: 100%;
        /* width: 40%; */
        height: 48px;
        /* margin-right: 20px; */
        /* &:last-child {
          margin-right: 0;
        } */
      }
      .ant-btn:hover,
      .ant-btn:focus {
        color: #000000a6;
        background-color: #fff;
        border-color: #834aff;
      }
      .ant-btn {
        position: relative;
        background-color: #fff;
        border-color: rgba(217, 217, 217, 1);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .check-store {
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .isChecked {
        border-color: #834aff;
      }
    }
  }
  .store-content {
    .store-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      font-family: ArialMT;
      margin-bottom: 17px;
      img {
        margin-right: 8px;
      }
    }
  }
`;
export const ProductCopyModal = (props) => {
  const {updateRoute} = useUpdateRoute();
  const {formatMessage, formatMessageMock} = useIntlTyped(localeMessage);
  const queries = useMemo(() => qs.parse(window.location.search), [window.location.search]);
  const {shops: shopsRaw} = useShopsModel();
  const countries = useMemo(() => {
    return shopsRaw.map((_2) => {
      return {
        countryCode: _2.countryCode,
        country: _2.country
      };
    }).reduce((acc, cur) => {
      if (!acc.find((_2) => _2.countryCode === cur.countryCode)) {
        acc.push(cur);
      }
      return acc;
    }, []);
  }, [shopsRaw]);
  const [countryCode] = useState(queries?.countryCode || countries[0]?.countryCode);
  const {isCopyVisible, IsCopyProductCount, productList, channelType = CHANNEL_TYPE_ENUM.MASTER} = props;
  const [StoreList, setStoreList] = useState([]);
  const [allStoreList, setAllStoreList] = useState([]);
  const [allChannelList, setAllChannelList] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [InfoIsLoading, setInfoIsLoading] = useState(true);
  const [CheckedStore, setCheckedStore] = useState([]);
  const refCheckedStore = useRef(CheckedStore);
  refCheckedStore.current = CheckedStore;
  const [_, forceUpdate] = useState([]);
  const [CheckChannel, setCheckChannel] = useState({
    ChannelName: "",
    ChannelId: ""
  });
  const refCheckChannel = useRef(CheckChannel);
  refCheckChannel.current = CheckChannel;
  const [IsNoChecked, setIsNoChecked] = useState(false);
  const refIsNoChecked = useRef(IsNoChecked);
  refIsNoChecked.current = IsNoChecked;
  useEffect(() => {
    init();
  }, [isCopyVisible]);
  const init = async () => {
    try {
      let data = await request.post(`/infra/integration/my/search`, {
        application: "SYS_ERP",
        authorizationStatus: "CONNECTED",
        integrationType: "MARKETPLACE"
      });
      data = data?.map((item) => {
        return {
          ...item,
          channelName: item?.integrationMarketplaceName || "",
          channelId: item?.integrationMarketplace || "",
          shopName: item?.name || ""
        };
      });
      setInfoIsLoading(true);
      let formatChannelList = {};
      if (localStorage.formatChannelList) {
        formatChannelList = JSON.parse(localStorage.formatChannelList);
      }
      const filterChannelList = [
        "JD_ID",
        "JD_V2",
        "TIKI_ID",
        "ZALORA_ID",
        "AKULAKU_ID",
        "JD_TH",
        "MAGENTO_ID",
        "WIX_ID",
        "MOKA_POS_ID",
        "MANUAL_ID",
        "GINEE_POS"
      ];
      if (data) {
        const shopList = data.filter((lData) => !filterChannelList.includes(lData.channelId) && lData.countryCode === (queries?.countryCode || countryCode));
        const channelList = [];
        const onlyChannelStoreList = [];
        shopList.filter((item) => {
          if (channelList.includes(item.channelId)) {
          } else {
            channelList.push(item.channelId);
            onlyChannelStoreList.push(item);
          }
        });
        setAllStoreList(shopList);
        setStoreList(shopList.filter((item) => item.channelId === channelList[0]));
        setAllChannelList(onlyChannelStoreList.map((i) => {
          if (i.channelId === channelList[0]) {
            i.checked = true;
          } else {
            i.checked = false;
          }
          return i;
        }));
        setInfoIsLoading(false);
      } else {
        setInfoIsLoading(false);
      }
    } catch (error) {
      setInfoIsLoading(false);
      handleError(error);
    }
  };
  const handelCheckChannel = (item) => {
    setCheckChannel({
      ChannelName: item.channelName,
      ChannelId: item.channelId
    });
    setStoreList(allStoreList.filter((i) => i.channelName === item.channelName));
    setAllChannelList(allChannelList.map((i) => {
      if (i.channelName === item.channelName) {
        i.checked = true;
      } else {
        i.checked = false;
      }
      return i;
    }));
    setCheckedStore([]);
  };
  const handelCancelCopy = () => {
    props.handelCancelCopy();
  };
  const handelChecked = (e) => {
    setCheckedStore(e);
    if (Array.isArray(e) && e.length > 0) {
      setIsNoChecked(false);
    }
  };
  const CopyDraft = async () => {
    try {
      const params = {
        productIds: productList,
        targetShopIds: refCheckedStore.current
      };
      const requestUrl = CLONE_PATH_ENUM[channelType] || "saas/product/batch_clone";
      let data = await axios.post(requestUrl, params);
      if (data && channelType !== CHANNEL_TYPE_ENUM.MASTER) {
        props.handelCancelCopy(true, {
          taskId: data.data,
          shopIds: refCheckedStore.current,
          productIds: productList,
          CheckChannel: StoreList[0].channelName,
          CheckChannelId: StoreList[0].channelId,
          countryCode: StoreList[0].countryCode
        });
        return;
      }
      setIsLoading(false);
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      setIsNoChecked(false);
    }
  };
  const handelSaveCopy = () => {
    if (Array.isArray(refCheckedStore.current) && refCheckedStore.current.length > 0) {
      setIsNoChecked(false);
      setIsLoading(true);
      CopyDraft();
    } else {
      setIsNoChecked(true);
    }
  };
  useEffect(() => {
    localStorage.removeItem("shopeeEditProductList");
  }, []);
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "chooseDestinationStore"}),
    width: 700,
    visible: isCopyVisible,
    onCancel: () => handelCancelCopy(),
    bodyStyle: {padding: "16px 24px 20px"},
    footer: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, {
      onClick: () => {
        handelCancelCopy();
      }
    }, formatMessage({id: "cancel"})), Array.isArray(StoreList) && StoreList.length > 0 ? /* @__PURE__ */ React.createElement(Button, {
      loading: IsLoading,
      type: "primary",
      onClick: () => handelSaveCopy()
    }, formatMessage({
      id: "copyAsDraft"
    })) : /* @__PURE__ */ React.createElement(Button, {
      type: "primary",
      onClick: () => updateRoute("integrations")
    }, formatMessage({id: "addStore"})))
  }, InfoIsLoading && /* @__PURE__ */ React.createElement(Spin, null), !InfoIsLoading && /* @__PURE__ */ React.createElement(ProductCopyModalStyled, null, /* @__PURE__ */ React.createElement("div", {
    className: "store-default-checked"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "checked-top"
  }, /* @__PURE__ */ React.createElement("img", {
    src: cloneImage,
    width: 20,
    height: 20
  }), /* @__PURE__ */ React.createElement("b", null, " ", IsCopyProductCount), /* @__PURE__ */ React.createElement("span", null, formatMessage({
    id: "chooseDestinationStore"
  }))), /* @__PURE__ */ React.createElement(Row, {
    gutter: 20,
    className: "checked-btn"
  }, !isEmpty(allChannelList) && getSortChannelList(allChannelList).map((item, index) => {
    return /* @__PURE__ */ React.createElement(Col, {
      key: index,
      span: 6
    }, /* @__PURE__ */ React.createElement(Button, {
      size: "large",
      onClick: () => handelCheckChannel(item),
      className: classNames({
        isChecked: item.checked
      })
    }, /* @__PURE__ */ React.createElement(ChannelIcon, {
      style: {marginRight: 6},
      channelId: item.channelId
    }), /* @__PURE__ */ React.createElement("span", null, item.channelName), item.checked && /* @__PURE__ */ React.createElement("img", {
      src: checkImage,
      className: "check-store",
      width: "28",
      height: "28"
    })));
  }))), /* @__PURE__ */ React.createElement("div", {
    className: "store-content"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "store-top"
  }, /* @__PURE__ */ React.createElement("img", {
    src: storeImage,
    width: 20,
    height: 20
  }), formatMessage({id: "selectStore"}), ":"), /* @__PURE__ */ React.createElement("div", {
    className: "store-check-group"
  }, Array.isArray(StoreList) && StoreList.length > 0 ? /* @__PURE__ */ React.createElement(CheckboxGroup, {
    style: {width: "100%"},
    value: refCheckedStore.current,
    onChange: (e) => handelChecked(e)
  }, /* @__PURE__ */ React.createElement(Row, null, StoreList.map((item, index) => /* @__PURE__ */ React.createElement(Col, {
    span: 8,
    key: item.id
  }, /* @__PURE__ */ React.createElement(Checkbox, {
    value: item.id
  }, /* @__PURE__ */ React.createElement("span", {
    style: {
      display: "inline-block"
    }
  }, item.shopName.length > 16 ? `(${item.countryCode}) ${item.shopName.substring(0, 16)}...` : `(${item.countryCode}) ${item.shopName}`)))))) : /* @__PURE__ */ React.createElement("span", {
    style: {color: "#f5222d"}
  }, formatMessage({
    id: "selectStore"
  }))), refIsNoChecked.current && /* @__PURE__ */ React.createElement("div", {
    style: {color: "#f5222d"}
  }, formatMessage({
    id: "chooseStoreLimit"
  })))));
};
export default ProductCopyModal;
